import React from "react";
import useInterview, { initialState } from "./interview-engine/useInterview";
import useActivities from "./interview-engine/useActivities";
import {
  loadInterview,
  saveInterview
} from "./interview-engine/loadSaveInterview";

// prettier-ignore
export type InterviewContextType = 
  ReturnType<typeof useInterview> &
  ReturnType<typeof useActivities> & {
    loadInterview: (input: HTMLInputElement) => void;
    saveInterview: () => void;
  };

const InterviewContext = React.createContext<InterviewContextType>({
  // interview stuff
  interviewState: initialState,
  startInterview: _ => ({}),
  changeInterviewName: _ => ({}),
  answerQuestion: _ => ({}),
  abandonInterview: () => ({}),
  confirmAbandonInterview: () => ({}),
  // activity stuff
  activities: [],
  addActivity: _ => ({}),
  updateActivity: _ => ({}),
  removeActivity: _ => ({}),
  clearAllActivities: () => ({}),
  restoreActivities: _ => ({}),
  //persistence stuff
  saveInterview: () => ({}),
  loadInterview: _ => ({})
});

function InterviewContextProvider({ children }: React.Props<any>) {
  const interviewState = useInterview();
  const activityState = useActivities();

  const loadInterviewWrapper = async (input: HTMLInputElement) => {
    try {
      const interview = await loadInterview(input);
      interviewState.startInterview(interview.interview);
      activityState.clearAllActivities();
      activityState.restoreActivities(interview.activities);
    } catch (error) {
      throw error;
    }
  };

  const saveInterviewWrapper = () => {
    saveInterview({
      interview: interviewState.interviewState.interview!,
      activities: activityState.activities
    });
  };

  return (
    <InterviewContext.Provider
      value={{
        ...interviewState,
        ...activityState,
        loadInterview: loadInterviewWrapper,
        saveInterview: saveInterviewWrapper
      }}
    >
      {children}
    </InterviewContext.Provider>
  );
}

export { InterviewContext, InterviewContextProvider };
